import { createdATFilter } from 'modules/common/constants';

export const areaFilters = [createdATFilter];
